import type { TPortableText } from '@typings/TPortableText';

export const isBlockContentEmpty = (block?: TPortableText | null) => {
  return !(
    !!block
    && !!block.length
    && block.some(b => (
      b._type === 'inlineImage'
      || (
        !!b.children.length
        && b.children.some(c => !!c.text.trim())
      )
    )));
}